  <form [formGroup]="formGroup" [ngClass]="{'column': componentInDialog }">
    <div class="radio__group">
        <p>TIPO DE PRODUTO</p>
        <mat-radio-group [disabled]="!isSearch" (change)="radioProposalsTypeSelected($event)" formControlName="IdTipoSetorProposta">
          <mat-radio-button [value]="setor.id" *ngFor="let setor of listTipoSetorProposta">{{ setor.descricao }}</mat-radio-button>
        </mat-radio-group>
    </div>
    <div class="radio__group form__group">
      <mat-label>Tipo de Proposta</mat-label>
      <mat-form-field appearance="outline" class="form__field">
        <mat-select [disabled]="!isSearch" formControlName="IdTipoProposta" placeholder="Selecione uma opção" *ngIf="idTipoSetorProposta === tipoSetorPropostaEnum.Publico" [disabled]="!validTipoSetorProposta">
          <mat-option *ngFor="let tipoProposta of listaPropostasSetorPublico" [value]="tipoProposta.value" (click)="selectTypeProposal(tipoProposta)">
            {{ tipoProposta.viewValue }}
          </mat-option>
        </mat-select>
        <mat-select formControlName="IdTipoProposta" placeholder="Selecione uma opção" *ngIf="idTipoSetorProposta === tipoSetorPropostaEnum.Privado" [disabled]="!validTipoSetorProposta">
          <mat-option [disabled]="!isSearch" *ngFor="let tipoProposta of listaPropostasSetorPrivado" [value]="tipoProposta.value" (click)="selectTypeProposal(tipoProposta)">
            {{ tipoProposta.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
</form>
